export default "__VITE_ASSET__DveWA_B4__"